import { createGlobalStyle } from 'styled-components/macro';

import AlrightSansRegularTTF from '../assets/fonts/AlrightSansFamily/AlrightSansRegular/3166ad31-2182-4fd1-9d82-7f10d4b7643e-1.ttf';
import AlrightSansRegularEOT from '../assets/fonts/AlrightSansFamily/AlrightSansRegular/3166ad31-2182-4fd1-9d82-7f10d4b7643e-2.eot';
import AlrightSansRegularWOFF from '../assets/fonts/AlrightSansFamily/AlrightSansRegular/3166ad31-2182-4fd1-9d82-7f10d4b7643e-3.woff';

import AlrightSansMediumTTF from '../assets/fonts/AlrightSansFamily/AlrightSansMedium/5f0232d6-b8f7-4780-babe-eb4163b9484d-1.ttf';
import AlrightSansMediumEOT from '../assets/fonts/AlrightSansFamily/AlrightSansMedium/5f0232d6-b8f7-4780-babe-eb4163b9484d-2.eot';
import AlrightSansMediumWOFF from '../assets/fonts/AlrightSansFamily/AlrightSansMedium/5f0232d6-b8f7-4780-babe-eb4163b9484d-3.woff';

import AlrightSansBoldTTF from '../assets/fonts/AlrightSansFamily/AlrightSansBold/61992ac3-1582-4b76-9057-2e219552f837-1.ttf';
import AlrightSansBoldEOT from '../assets/fonts/AlrightSansFamily/AlrightSansBold/61992ac3-1582-4b76-9057-2e219552f837-2.eot';
import AlrightSansBoldWOFF from '../assets/fonts/AlrightSansFamily/AlrightSansBold/61992ac3-1582-4b76-9057-2e219552f837-3.woff';

import AlrightSansLightTTF from '../assets/fonts/AlrightSansFamily/AlrightSansThin/c088677c-ef3e-4a6e-ac49-3a0bdd785689-1.ttf';
import AlrightSansLightEOT from '../assets/fonts/AlrightSansFamily/AlrightSansThin/c088677c-ef3e-4a6e-ac49-3a0bdd785689-2.eot';
import AlrightSansLightWOFF from '../assets/fonts/AlrightSansFamily/AlrightSansThin/c088677c-ef3e-4a6e-ac49-3a0bdd785689-3.woff';

import { grayBG, grayText } from './colors';
import './icons.css';

export default createGlobalStyle`

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body, html, #root {
  height: 100%;
}

.App {
  flex-grow: 1;
  width: 100%;
}

#root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sticky_sentinel {
  max-width: 0;
}

@font-face {
  font-family: "AlrightSansRegular";
  src: url(${AlrightSansRegularTTF});
  src: url(${AlrightSansRegularEOT}) format("embedded-opentype"),
       url(${AlrightSansRegularWOFF}) format("woff"),
       url(${AlrightSansRegularTTF}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "AlrightSansRegular";
  src: url(${AlrightSansLightTTF});
  src: url(${AlrightSansLightEOT}) format("embedded-opentype"),
       url(${AlrightSansLightWOFF}) format("woff"),
       url(${AlrightSansLightTTF}) format("truetype");
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: "AlrightSansRegular";
  src: url(${AlrightSansMediumTTF});
  src: url(${AlrightSansMediumEOT}) format("embedded-opentype"),
       url(${AlrightSansMediumWOFF}) format("woff"),
       url(${AlrightSansMediumTTF}) format("truetype");
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: "AlrightSansRegular";
  src: url(${AlrightSansBoldTTF});
  src: url(${AlrightSansBoldEOT}) format("embedded-opentype"),
       url(${AlrightSansBoldWOFF}) format("woff"),
       url(${AlrightSansBoldTTF}) format("truetype");
  font-style: normal;
  font-weight: bold;
}


body {
  font-family: "AlrightSansRegular", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  max-width: 100vw;
  background-color: ${grayBG};
  color: ${grayText};
  width: 100%;
}
`;
